import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthSessionServiceDelegate } from '../../../authentication/services/delegate.auth.session.service';
import { RedirectionContextService } from '../services/redirection-context.service';
import { CanNavigateInStepperService } from '../../shared/services/can-navigate-in-stepper.service';
import { RedirectionContext } from '../models/redirection-context';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
  selector: 'app-profil-acheteur',
  templateUrl: './profil-acheteur.component.html'
})
export class ProfilAcheteurComponent implements OnInit {

  constructor(
    private router: Router,
    private authSessionService: AuthSessionServiceDelegate,
    private route: ActivatedRoute,
    private redirectionContextService: RedirectionContextService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private spinner: SpinnerVisibilityService
  ) { }

  /**
   * Récupère les données de connexion via l'URL de redirection transférée au profil acheteur, puis crée une session
   * @param id : UUID de l'utilisateur, pour effectuer des action sur l'application
   * @param oauthToken : Token Oauth transmis par le back, pour authentifier l'utilisateur
   * @returns renvoie vers la page principale si connecté, ou la page de login si profil non validé
   */
  ngOnInit(): void {
    this.authSessionService.isReady()
    .subscribe(
      () => this.redirectUser(this.route.snapshot.queryParamMap.get('redirection_context_id'))
    )
  }

  private redirectUser(redirectionContextId: string) {
    if (redirectionContextId === null) {
      this.router.navigate(['/accueil'])
    } else {
      this.spinner.show();
      // FIXME avoid calling redirection context twice
      this.redirectionContextService.getRedirectionContext(redirectionContextId)
        .subscribe(
          (context: RedirectionContext) => {
            const reference = context.payload?.consultationReferences?.reference;
            if (reference) {
              // Stocker la référence dans le service pour récupération ultérieure
              this.canNavigateInStepperService.reference = reference;
              // Naviguer avec queryParams pour indiquer un décrochage depuis PLACE
              // Cela permet d'éviter la requête initiale inutile et de charger directement les avis filtrés
              this.router.navigate(['/avisdepublicite/listerAvisPub'], {
                queryParams: { fromPlace: 'true', ref: reference }
              });
            } else {
              this.router.navigate(['/accueil'])
            }
            this.spinner.hide();
          })
    }
  }
}
